import React, { useEffect, useState } from "react";
import { StyledCampusAbout } from "./CampusAboutTab.styles";
import { useTranslation } from "react-i18next";

//img
{
  /*TODO: Display contacts data*/
}
// import phoneIcon from "src/assets/images/campusContacts/phone.svg";
// import emailIcon from "src/assets/images/campusContacts/email.svg";
// import { Link } from "react-router-dom";
import { RootReducer } from "../../../../../redux/reducers";
import { useSelector } from "react-redux";
import { GetSchoolsItemResponseTypes } from "../../../../../redux/actions/schools/types";
import noPhoto from "../../../../../assets/images/noPhoto.svg";

interface IProps {
  campusId: number;
}

const CampusAboutTab: React.FC<IProps> = ({ campusId }) => {
  const [t] = useTranslation();
  const [campus, setCampus] = useState<GetSchoolsItemResponseTypes | undefined>(undefined);

  const {
    schools: { school }
  }: RootReducer = useSelector<RootReducer>((state) => state) as RootReducer;

  useEffect(() => {
    setCampus(school?.campuses?.find((item) => item.id === campusId));
  }, [campusId]);

  return (
    <StyledCampusAbout>
      <div className="grph-top">
        <p className="chart-title">
          <b>{t("school_campus_details")}</b>
        </p>
        <div className="grph-btn">
          {/* TODO: Display edit campus btn */}
          {/*<button type="button" className="btn btn-labeled btn-default btn-edit">*/}
          {/*  {t("school_campus_edit_btn")}*/}
          {/*  <span className="btn-label">*/}
          {/*    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
          {/*      <path*/}
          {/*        fillRule="evenodd"*/}
          {/*        clipRule="evenodd"*/}
          {/*        d="M15.947 2.0734C16.1931 1.83194 16.5269 1.69629 16.8749 1.69629C17.2229 1.69629 17.5567 1.83194 17.8028 2.0734L20.4278 4.64943C20.6739 4.89097 20.8121 5.21852 20.8121 5.56005C20.8121 5.90159 20.6739 6.22914 20.4278 6.47068L8.61534 18.0628C8.47165 18.2042 8.29641 18.3109 8.10347 18.3745L4.16597 19.6625C3.93464 19.7385 3.68629 19.7497 3.44882 19.6949C3.21134 19.6401 2.99413 19.5215 2.82156 19.3523C2.64899 19.183 2.52789 18.97 2.47186 18.737C2.41582 18.504 2.42707 18.2602 2.50434 18.0332L3.81684 14.1691C3.88142 13.9793 3.99017 13.8069 4.13447 13.6655L15.947 2.0734V2.0734ZM16.8749 2.98403L19.4999 5.56005L7.68741 17.1522L3.74991 18.4402L5.06241 14.5761L16.8749 2.98403Z"*/}
          {/*        fill="#165B95"*/}
          {/*      ></path>*/}
          {/*      <path*/}
          {/*        fillRule="evenodd"*/}
          {/*        clipRule="evenodd"*/}
          {/*        d="M17.0666 8.59191L13.7854 5.37187L14.7146 4.45996L17.9959 7.67999L17.0679 8.59191H17.0666ZM5.0625 13.288V13.932C5.0625 14.1028 5.13164 14.2666 5.25471 14.3874C5.37778 14.5082 5.5447 14.576 5.71875 14.576H6.375V15.22C6.375 15.3908 6.44414 15.5546 6.56721 15.6754C6.69028 15.7962 6.8572 15.864 7.03125 15.864H7.6875V16.508C7.6875 16.6788 7.75664 16.8426 7.87971 16.9634C8.00278 17.0842 8.1697 17.152 8.34375 17.152H9V15.22C9 15.0492 8.93086 14.8854 8.80779 14.7646C8.68472 14.6439 8.5178 14.576 8.34375 14.576H7.6875V13.932C7.6875 13.7612 7.61836 13.5974 7.49529 13.4766C7.37222 13.3559 7.2053 13.288 7.03125 13.288H5.0625Z"*/}
          {/*        fill="#165B95"*/}
          {/*      ></path>*/}
          {/*      <path*/}
          {/*        fillRule="evenodd"*/}
          {/*        clipRule="evenodd"*/}
          {/*        d="M17.0018 8.7504L13.5592 5.37203L14.7145 4.23828L18.2217 7.68007L17.1326 8.7504H17.0018ZM4.90405 13.1298H7.03114C7.24622 13.1298 7.45309 13.2136 7.60607 13.3638C7.75916 13.514 7.84572 13.7184 7.84572 13.9322V14.4178H8.34364C8.55873 14.4178 8.76559 14.5017 8.91857 14.6518C9.07166 14.802 9.15822 15.0064 9.15822 15.2202V17.3105H8.34364C8.12855 17.3105 7.92168 17.2267 7.7687 17.0766C7.61561 16.9264 7.52905 16.722 7.52905 16.5082V16.0225H7.03114C6.81605 16.0225 6.60918 15.9387 6.4562 15.7886C6.30311 15.6383 6.21655 15.4339 6.21655 15.2202V14.7345H5.71864C5.50355 14.7345 5.29668 14.6507 5.1437 14.5006C4.99061 14.3503 4.90405 14.1459 4.90405 13.9322V13.1298ZM5.06239 13.9322C5.06239 14.103 5.13153 14.2668 5.2546 14.3875C5.37767 14.5083 5.54459 14.5762 5.71864 14.5762H6.37489V15.2202C6.37489 15.391 6.44403 15.5548 6.5671 15.6756C6.69017 15.7963 6.85709 15.8642 7.03114 15.8642H7.68739V16.5082C7.68739 16.679 7.75653 16.8428 7.8796 16.9636C8.00267 17.0844 8.16959 17.1522 8.34364 17.1522H8.99989V15.2202C8.99989 15.0494 8.93075 14.8856 8.80768 14.7648C8.6846 14.644 8.51768 14.5762 8.34364 14.5762H7.68739V13.9322C7.68739 13.7614 7.61825 13.5976 7.49518 13.4768C7.3721 13.356 7.20518 13.2882 7.03114 13.2882H5.06239V13.9322ZM17.0678 8.59207H17.0665L13.7853 5.37203L14.7145 4.46013L17.9958 7.68015L17.0678 8.59207Z"*/}
          {/*        fill="#165B95"*/}
          {/*      ></path>*/}
          {/*      <path*/}
          {/*        d="M2 21.8083C2 21.371 2.35444 21.0166 2.79167 21.0166H20.4583C20.8956 21.0166 21.25 21.371 21.25 21.8083V21.9423C21.25 22.3795 20.8956 22.734 20.4583 22.734H2.79167C2.35444 22.734 2 22.3795 2 21.9423V21.8083Z"*/}
          {/*        fill="#165B95"*/}
          {/*      ></path>*/}
          {/*    </svg>*/}
          {/*  </span>*/}
          {/*</button>*/}
        </div>
      </div>
      <div className={`campusPhoto ${!campus?.imageUrl && "noPhoto"}`}>
        {<img src={campus?.imageUrl || noPhoto} alt="Campus" />}
      </div>
      <div className="campusDescription">{campus?.description}</div>
      {/*TODO: Display contact data*/}
      {/*<div className="campusContacts">*/}
      {/*  <div className="item">*/}
      {/*    <img className="itemIcon" src={phoneIcon} alt="phone" />*/}
      {/*    <div className="itemWrapper">*/}
      {/*      <span className="label">Phone Number</span>*/}
      {/*      <Link to="tel:+61123456789">+61123456789</Link>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="item">*/}
      {/*    <img className="itemIcon" src={emailIcon} alt="email" />*/}
      {/*    <div className="itemWrapper">*/}
      {/*      <span className="label">E-Mail</span>*/}
      {/*      <Link to="mailto:Dummy@mail.com">Dummy@mail.com</Link>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </StyledCampusAbout>
  );
};

export default CampusAboutTab;
